import { useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import "../styles/section-more.css";

// const refresh_token = sessionHandler("session_token", null, "get");

const SectionMore = () => {
  useEffect(() => {}, []);

  return (
    <div className="section-more">
      <div className="section-one"></div>
      <div className="section-two"></div>
    </div>
  );
};

export default SectionMore;
